// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuoteRejectedItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackQuoteRejectedParameters
    extends TrackEventListParameters<"has_notes" | "type", null, TrackQuoteRejectedItem> {}

const trackQuoteRejected = (parameters: TrackQuoteRejectedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "quote_rejected", ...parameters }, options);
};

export default trackQuoteRejected;
